import { Modal } from '@mantine/core';
import { useState, useRef } from 'react';
import { IconHelp } from '@tabler/icons-react';
import { SelectTooltip, VisiLoader } from "../../GeneralComponent/GeneralComponent";
import { UniversalSmartCodeContent, useUniversalSmartCode } from '../../GeneralComponent/UniversalSmartCodeContent';
import ReactDOM from 'react-dom';
import AdvancedTrackingConfig from '../../Funnel/AdvancedTrackingConfig';

interface UniversalSmartCodeModalProps {
  opened: boolean;
  onClose: () => void;
  websiteId: string | number;
  websiteUrl: string;
  subdomainVisiSmartCode: boolean;
  visiSmartCodeSubdomainId: string | number;
  showAdvancedTracking?: boolean;
  pageId?: string;
  showShopifyConfirmationCode?: boolean;
}

export function UniversalSmartCodeModal({ opened, onClose, websiteId, websiteUrl, subdomainVisiSmartCode, visiSmartCodeSubdomainId, showAdvancedTracking = true, pageId = '', showShopifyConfirmationCode = true }: UniversalSmartCodeModalProps) {
  const { data, loading, reload } = useUniversalSmartCode({
    websiteId,
    isSubdomain: subdomainVisiSmartCode,
    subdomainId: visiSmartCodeSubdomainId,
    pageId,
    enabled: opened,
  });

  const visismartCodeRef = useRef(null);
  const ghlCssref = useRef(null);
  const ghlSmartCodeRef = useRef(null);
  const footerCodeRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [helpTargetId, setHelpTargetId] = useState(0);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

  const handleHelpClick = (id:any) => {
      setShowHelpModal(true);
      setHelpTargetId(id);
      const iconRefMapping = {
        188: visismartCodeRef,
        371: footerCodeRef,
        370: ghlSmartCodeRef,
        369: visismartCodeRef,
        372: visismartCodeRef,
        374: visismartCodeRef,
        363: ghlCssref,
        377: visismartCodeRef
      };
      let iconRef = iconRefMapping[id];
      if (iconRef.current) {
        const { top, left, width } = iconRef.current.getBoundingClientRect();
        const scrollOffset = window.scrollY;
        setTooltipPosition({
          top: top + scrollOffset,
          left: left + width + 10,
        });
      }
  };

  return (
    <>
      {showHelpModal &&
        ReactDOM.createPortal(
          <div>
            <SelectTooltip
              isVisible={showHelpModal}
              setIsVisible={setShowHelpModal}
              id={helpTargetId}
              tooltipPosition={tooltipPosition}
            />
          </div>,
        document.body
      )}
      <Modal.Root size="70%" opened={opened} onClose={onClose} trapFocus={false}>
        <Modal.Overlay />
        <Modal.Content>
          <VisiLoader VisiLoaderVisible={loading} />
          <Modal.Header>
            <Modal.Title>UNIVERSAL SMART CODE <IconHelp ref={visismartCodeRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(data.frontendFramework === '3' ? 369 : data.frontendFramework === '2' ? 372 : data.frontendFramework === '1' ? 374 : data.frontendFramework === '0' ? 377 : 188)}/></Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            {/* ADVANCED TRACKING DOMAIN SECTION - ABOVE TRACKING CODE */}
            {/* Note: AdvancedTrackingConfig returns null when user has no permission */}
            {showAdvancedTracking && (
              <AdvancedTrackingConfig
                websiteId={websiteId as string}
                websiteUrl={websiteUrl}
                onConfigChange={reload}
              />
            )}
            {/* END ADVANCED TRACKING SECTION */}

            <UniversalSmartCodeContent
              data={data}
              showShopifyConfirmationCode={showShopifyConfirmationCode}
              ghlCssref={ghlCssref}
              ghlSmartCodeRef={ghlSmartCodeRef}
              footerCodeRef={footerCodeRef}
              handleHelpClick={handleHelpClick}
            />
          </Modal.Body>
        </Modal.Content>
      </Modal.Root>
    </>
  );
}
